import AttachmentCheck from './src/main';

/* istanbul ignore next */
AttachmentCheck.install = function(Vue) {
  Vue.component(AttachmentCheck.name, AttachmentCheck);
};

export default AttachmentCheck;
